import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App, { ROUTE_PRELOADERS } from "@/App";

const rootEl = document.getElementById("root");
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if (rootEl.hasChildNodes()) {
  // Prerendered page: load the current route's chunk first so hydration
  // doesn't suspend, then adopt the static DOM. Hydration itself is deferred
  // until first interaction (or 8s) so it never blocks the initial paint.
  const path = window.location.pathname.replace(/\/+$/, "") || "/";
  const preload = ROUTE_PRELOADERS[path];
  let started = false;
  const events = ["pointerdown", "keydown", "touchstart", "wheel", "mousemove", "scroll"];
  const start = () => {
    if (started) return;
    started = true;
    events.forEach((e) => window.removeEventListener(e, start));
    Promise.resolve(preload ? preload() : null)
      .catch(() => {})
      .then(() => {
        ReactDOM.hydrateRoot(rootEl, app, { onRecoverableError: () => {} });
      });
  };
  events.forEach((e) => window.addEventListener(e, start, { passive: true, once: true }));
  const AUTH_PATHS = ["/login", "/signup", "/forgot-password", "/reset-password"];
  if (window.__ocsvI || AUTH_PATHS.includes(path)) start();
  else setTimeout(start, 8000);
} else {
  ReactDOM.createRoot(rootEl).render(app);
}
